import ListImagesView from './list-images-view'
import Core from '../core'

Core.Tasks.add(() => {
    new ListImagesView()
})
